import { liveFeed } from "@/mocks/home";

export default function LiveFeedBar() {
  const items = [...liveFeed, ...liveFeed];
  return (
    <section aria-label="实时整理动态" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto flex max-w-[1400px] items-center gap-4 px-4 py-3 md:px-6">
        <span className="flex shrink-0 items-center gap-2 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-semibold text-background-50">
          <i className="ri-pulse-line text-sm" />
          实时整理
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8">
            {items.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-600"
              >
                <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-500" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}